const now = new Date();
const hoursAgo = (h) => new Date(now.getTime() - h * 3600000).toISOString();

const MOCK_WIDGET_DATA = {
  'w1-notes-0001': {
    data: {
      title: 'Notas',
      items: [
        {
          id: 'n1',
          title: 'Seguimiento de cliente',
          description: 'Confirmar demo para la proxima semana con el equipo de producto',
          dueDate: 'Abr 8',
          author: 'Diego',
          date: hoursAgo(2),
          timeAgo: '2h ago',
          metadata: { commentsCount: 2, attachmentsCount: 1, tasksCount: 1 },
        },
        {
          id: 'n2',
          title: 'Preferencia de contacto',
          description: 'El cliente prefiere comunicacion por email, no llamadas antes de las 10am',
          dueDate: 'Abr 12',
          author: 'Camila',
          date: hoursAgo(18),
          timeAgo: '18h ago',
          metadata: { commentsCount: 0, attachmentsCount: 0, tasksCount: 2 },
        },
        {
          id: 'n3',
          title: 'Producto de interes',
          description: 'Interesado en Plan Pro anual. Pedir aprobacion de descuento del 15%',
          dueDate: 'Abr 15',
          author: 'Diego',
          date: hoursAgo(48),
          timeAgo: '2d ago',
          metadata: { commentsCount: 3, attachmentsCount: 2, tasksCount: 0 },
        },
      ],
    },
    meta: { is_empty: false, error: null, pagination: null },
  },
  'w2-activity-0001': {
    data: {
      title: 'Actividad',
      items: [
        {
          id: 'a1',
          type: 'call',
          title: 'Llamada con prospecto',
          description: 'Se revisaron opciones de plan y pricing',
          author: 'Equipo SDR',
          date: hoursAgo(1),
          timeAgo: '1h ago',
          metadata: {
            userId: 'usr-10',
            sentiment: 'positive',
            assignedTasks: 1,
            hasExternalLink: true,
            direction: 'outbound',
            duration: '12:34',
            commentsCount: 1,
            attachmentsCount: 0,
            linkCount: 1,
          },
        },
        {
          id: 'a2',
          type: 'email',
          title: 'Email de seguimiento enviado',
          description: 'Propuesta comercial con descuento incluido',
          author: 'Camila',
          date: hoursAgo(5),
          timeAgo: '5h ago',
          metadata: {
            userId: 'usr-11',
            assignedTasks: 0,
            hasExternalLink: false,
            commentsCount: 0,
            attachmentsCount: 1,
            linkCount: 0,
          },
        },
        {
          id: 'a3',
          type: 'chat',
          title: 'Chat interno sobre el deal',
          description: 'Equipo de ventas alineado en estrategia de cierre',
          author: 'Carlos',
          date: hoursAgo(24),
          timeAgo: '1d ago',
          alerts: [{ type: 'needs_attention', message: 'Requiere atencion del manager' }],
          metadata: {
            userId: 'usr-12',
            flagged: true,
            assignedTasks: 2,
            commentsCount: 4,
            attachmentsCount: 0,
            linkCount: 0,
          },
        },
        {
          id: 'a4',
          type: 'call',
          title: 'Llamada de descubrimiento',
          description: 'Primera toma de contacto con decision-maker',
          author: 'Diego',
          date: hoursAgo(72),
          timeAgo: '3d ago',
          metadata: {
            userId: 'usr-10',
            sentiment: 'neutral',
            direction: 'inbound',
            duration: '08:15',
            hasRecording: true,
            commentsCount: 2,
            attachmentsCount: 0,
            linkCount: 0,
          },
        },
      ],
    },
    meta: { is_empty: false, error: null, pagination: null },
  },
  'w3-standard-0001': {
    data: {
      title: 'Metricas',
      items: [
        { id: 'm1', content: 'Conversion: 24%' },
        { id: 'm2', content: 'Tickets abiertos: 3' },
        { id: 'm3', content: 'NPS: 72' },
        { id: 'm4', content: 'Tiempo medio de respuesta: 2.4h' },
      ],
    },
    meta: { is_empty: false, error: null, pagination: null },
  },
  'w4-standard-0002': {
    data: {
      title: 'Tareas',
      items: [
        { id: 't1', content: 'Enviar propuesta comercial' },
        { id: 't2', content: 'Agendar demo con equipo tecnico' },
        { id: 't3', content: 'Revisar contrato legal' },
      ],
    },
    meta: { is_empty: false, error: null, pagination: null },
  },
};

const FETCH_DELAY_MS = { min: 800, max: 2000 };

export const fetchWidgetData = async (
  instanceUuid,
  scopeContext,
  dashboardContext,
  widgetContext = null,
  options = {},
) => {
  void scopeContext;
  void dashboardContext;
  void widgetContext;

  const { signal } = options;
  if (signal?.aborted) {
    throw new DOMException('Aborted', 'AbortError');
  }

  const delay = FETCH_DELAY_MS.min + Math.random() * (FETCH_DELAY_MS.max - FETCH_DELAY_MS.min);
  await new Promise((resolve, reject) => {
    const timer = setTimeout(resolve, delay);
    if (signal) {
      signal.addEventListener('abort', () => {
        clearTimeout(timer);
        reject(new DOMException('Aborted', 'AbortError'));
      }, { once: true });
    }
  });

  const response = MOCK_WIDGET_DATA[instanceUuid] || {
    data: { title: 'Widget', items: [] },
    meta: { is_empty: true, error: null, pagination: null },
  };

  return response;
};
